/**
 * Validate thông tin cơ bản của người đánh giá (cho tất cả các forms)
 * @param {Object} reviewerInfo - Thông tin người đánh giá
 * @param {Function} t - Translation function
 * @returns {string|null} - Error message hoặc null nếu valid
 */
export const validateReviewerBasicInfo = (reviewerInfo, t) => {
  // Kiểm tra họ tên
  if (!reviewerInfo?.fullname) {
    return t('council.review.reviewerNameRequired');
  }
  return null;
};

/**
 * Validate đầy đủ general info cho Financial Review
 * Bao gồm cả thông tin thanh toán
 * @param {Object} generalInfo - Thông tin dự án
 * @param {Object} reviewerInfo - Thông tin người đánh giá
 * @param {Function} t - Translation function
 * @returns {string|null} - Error message hoặc null nếu valid
 */
export const validateGeneralInfoWithPayment = (generalInfo, reviewerInfo, t) => {
  const scientificProfile = reviewerInfo?.scientificProfile || {};

  // Kiểm tra tất cả các trường bắt buộc
  const hasAllFields =
    // Reviewer basic info
    reviewerInfo?.fullname &&
    reviewerInfo?.email &&
    (reviewerInfo?.organization?.name || reviewerInfo?.organization?.englishName) &&
    // Payment info
    scientificProfile.personalPhone &&
    (scientificProfile.taxIdentificationNumber || scientificProfile.citizenId) &&
    scientificProfile.bankAccount &&
    scientificProfile.bank &&
    // scientificProfile.personalAddress &&
    // Nếu có CCCD, phải có đầy đủ thông tin ngày cấp và nơi cấp
    (!scientificProfile.citizenId ||
      (scientificProfile.dateOfIssue && scientificProfile.placeOfIssue));

  if (!hasAllFields) {
    return t('errorMessage.pleaseUpdateProfile');
  }

  return null;
};
